var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-calendar-check" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("appointments")) + "\n\t")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _vm.showEvents
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "events",
                  label: _vm.$t("events")
                },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.showReactionTests && _vm.permissions.presential_full_view,
                expression:
                  "showReactionTests && permissions.presential_full_view"
              }
            ],
            attrs: {
              slot: "title",
              name: "reaction_tests",
              label: _vm.$t("reaction_tests")
            },
            slot: "title"
          }),
          _vm.showSupportMaterials && _vm.permissions.presential_full_view
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "supportMaterial",
                  label: _vm.$t("support_materials")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showGuests
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "guests",
                  label: _vm.$t("subscriptions")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showMaterials && _vm.permissions.presential_full_view
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "materials",
                  label: _vm.$t("inputs")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showEvidences && _vm.permissions.presential_full_view
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "evidences",
                  label: _vm.$t("evidences")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showCosts && _vm.permissions.presential_full_view
            ? _c("q-tab", {
                attrs: { slot: "title", name: "costs", label: _vm.$t("costs") },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showComments,
                expression: "showComments"
              }
            ],
            attrs: {
              slot: "title",
              name: "comments",
              label: _vm.$t("comments")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPresence,
                expression: "showPresence"
              }
            ],
            attrs: {
              slot: "title",
              name: "presence",
              label: _vm.$t("presence")
            },
            slot: "title"
          }),
          _vm.showResults
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "results",
                  label: _vm.$t("results")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showHistory && _vm.permissions.presential_full_view
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "history",
                  label: _vm.$t("history")
                },
                slot: "title"
              })
            : _vm._e(),
          _c(
            "q-tab-pane",
            {
              staticStyle: { padding: "5px 2px" },
              attrs: { name: "basic-data" }
            },
            [
              _c("basic-data", {
                attrs: {
                  auto_duplicate: _vm.auto_duplicate,
                  permissions: _vm.permissions,
                  full_name: _vm.full_name,
                  current_client: _vm.current_client
                },
                on: {
                  autoDuplicateTraining: _vm.autoDuplicateTraining,
                  updateEventsInfo: _vm.updateEventsInfo,
                  changeTab: _vm.changeTab,
                  changeTimezone: _vm.changeTimezone,
                  AcademiaCoralApprovalHandler: _vm.AcademiaCoralApprovalHandler
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            {
              staticStyle: { padding: "5px 2px" },
              attrs: { name: "events", "keep-alive": _vm.keep_alive_events }
            },
            [
              _c("events", {
                attrs: {
                  permissions: _vm.permissions,
                  events_live_class_isPublic: _vm.events_live_class_isPublic,
                  events_title: _vm.events_title,
                  events_description: _vm.events_description,
                  status: _vm.status,
                  timezone: _vm.timezone,
                  event_to_finish: _vm.event_to_finish
                },
                on: { keepAlive: _vm.keepAliveEvents }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "reaction_tests" } },
            [
              _c("reaction-tests", {
                attrs: { permissions: _vm.permissions, status: _vm.status }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "supportMaterial" } },
            [
              _c("supportMaterial", {
                attrs: {
                  manage_models: _vm.permissions.manage_models,
                  appointment_status: _vm.status
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "guests" } },
            [
              _c("guests", {
                attrs: {
                  permissions: _vm.permissions,
                  allowed_profiles: _vm.allowed_profiles,
                  allowed_areas: _vm.allowed_areas,
                  current_client: _vm.current_client,
                  status: _vm.status
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "materials" } },
            [
              _c("materials", {
                attrs: {
                  manage_models: _vm.permissions.manage_models,
                  status: _vm.status,
                  is_training_manager: _vm.permissions.trainings_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "evidences" } },
            [
              _c("evidences", {
                attrs: {
                  status: _vm.status,
                  is_training_manager: _vm.permissions.trainings_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "costs" } },
            [
              _c("costs", {
                attrs: {
                  status: _vm.status,
                  is_training_manager: _vm.permissions.trainings_manage
                }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "comments" } },
            [
              _c("comments", {
                attrs: { origin: "presential", presential_status: _vm.status }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "presence" } },
            [_c("presence", { attrs: { url: _vm.presenceUrl } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "results" } },
            [
              _c("results", {
                attrs: {
                  status: _vm.status,
                  events_title: _vm.events_title,
                  max_participants: _vm.max_participants,
                  permissions: _vm.permissions
                },
                on: { goToUnfinishedEvent: _vm.goToUnfinishedEvent }
              })
            ],
            1
          ),
          _c("q-tab-pane", { attrs: { name: "history" } }, [_c("history")], 1)
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-xs" }, [
        _vm.showDeleteButton
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("cancel")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("remove"),
                    icon: "fas fa-trash",
                    disable: !_vm.permissions.request_events
                  },
                  on: {
                    click: function($event) {
                      _vm.show_delete_model = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.showDuplicateButton
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("cancel")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "info",
                    label: _vm.$t("duplicate"),
                    icon: "far fa-copy",
                    disable: !_vm.permissions.request_events
                  },
                  on: {
                    click: function($event) {
                      _vm.show_duplicate_modal = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.showCancelandReprove
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("cancel")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("cancel_appointment"),
                    icon: "fas fa-times"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmCancelAppointment()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        (_vm.showCancelandReprove && _vm.status === 1) ||
        (_vm.showCancelandReprove && _vm.status === 2)
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("cancel")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "warning",
                    label: _vm.$t("reprove"),
                    icon: "fas fa-undo"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmReproveAppointment()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.showApprovalButtons
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "positive",
                    label: _vm.$t("approve"),
                    icon: "fas fa-check"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmApproveAppointment()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-xs" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "appointments" })
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        return _vm.hideApproval()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("approve") },
                    on: {
                      click: function($event) {
                        return _vm.saveApproval()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_approve,
            callback: function($$v) {
              _vm.show_approve = $$v
            },
            expression: "show_approve"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("approve_appointment")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("do_you_confirm_approving_this_appointment")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { type: "textarea", placeholder: _vm.$t("observation") },
                model: {
                  value: _vm.approve_observation,
                  callback: function($$v) {
                    _vm.approve_observation = $$v
                  },
                  expression: "approve_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        return _vm.hideReproval()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "warning", label: _vm.$t("reprove") },
                    on: {
                      click: function($event) {
                        return _vm.saveReproval()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_reprove,
            callback: function($$v) {
              _vm.show_reprove = $$v
            },
            expression: "show_reprove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("reprove_appointment")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("do_you_confirm_reproving_this_appointment")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: {
                  type: "textarea",
                  placeholder: _vm.$t("observation"),
                  error: _vm.$v.reprove_observation.$error
                },
                on: { input: _vm.$v.reprove_observation.$touch },
                model: {
                  value: _vm.reprove_observation,
                  callback: function($$v) {
                    _vm.reprove_observation = $$v
                  },
                  expression: "reprove_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        return _vm.hideCancel()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.saveCancel()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_cancel,
            callback: function($$v) {
              _vm.show_cancel = $$v
            },
            expression: "show_cancel"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("cancel_appointment")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "do_you_confirm_canceling_this_appointment_this_action_cannot_be_undone"
                )
              )
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: {
                  type: "textarea",
                  placeholder: _vm.$t("observation"),
                  error: _vm.$v.cancel_observation.$error
                },
                on: { input: _vm.$v.cancel_observation.$touch },
                model: {
                  value: _vm.cancel_observation,
                  callback: function($$v) {
                    _vm.cancel_observation = $$v
                  },
                  expression: "cancel_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_delete_model = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.deleteModel()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_delete_model,
            callback: function($$v) {
              _vm.show_delete_model = $$v
            },
            expression: "show_delete_model"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_model")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "do_you_confirm_removing_this_model_this_action_cannot_be_undone"
                )
              )
            )
          ])
        ]
      ),
      _c("duplicate", {
        attrs: { show: _vm.show_duplicate_modal },
        on: { hideDuplicate: _vm.hideDuplicate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }